import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=b41dace8&scoped=true&"
import script from "./ReportsList.vue?vue&type=script&lang=js&"
export * from "./ReportsList.vue?vue&type=script&lang=js&"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=b41dace8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41dace8",
  null
  
)

export default component.exports